import React from 'react';
import Select from 'react-select-v3';

import { getFilteredRoutes, isLocalOrCorridorAndDefinedAndEnabled } from 'reselects/routes';

import { StyledFilter, reactSelectStyles } from './styled';
import { useSelector } from 'react-redux';
import { constants, getSpecificClientConfig } from 'redux/modules/client-config/selectors';

const t = {
  placeholder: 'Select route',
};

const RoutesCombinedFilter = ({ selectProps = {}, value, onChange, stylingProps }) => {
  const routes = useSelector((state) =>
    getFilteredRoutes(state, isLocalOrCorridorAndDefinedAndEnabled)
  );
  const isLhFilterEnabled = useSelector((store) =>
    getSpecificClientConfig(store, constants.LH_FILTER)
  );

  const handleChange = (route) => {
    onChange(removeFilters(route, ['all']));
  };

  const regionalMappedRoutes = routes.map((route) => ({
    label: route.simple_name,
    value: route.simple_name,
  }));
  const lhRoutes = [
    {
      label: 'EMID',
      value: 'E_MID',
    },
    {
      label: 'LH ES',
      value: 'long_haul',
    },
    {
      label: 'LH FR',
      value: 'long_haul_fr',
    },
    {
      label: 'INT',
      value: 'international',
    },
  ];

  const options = [...regionalMappedRoutes, ...lhRoutes];

  return (
    <StyledFilter {...stylingProps}>
      <Select
        value={value?.length ? value : { label: 'All', value: 'all' }}
        closeMenuOnSelect
        isMulti
        options={isLhFilterEnabled ? options : regionalMappedRoutes}
        onChange={handleChange}
        styles={reactSelectStyles}
        placeholder={t.placeholder}
        {...selectProps}
      />
    </StyledFilter>
  );
};

RoutesCombinedFilter.filterName = 'RoutesCombinedFilter';

function removeFilters(routes, filtersToRemove) {
  return (routes || []).filter((route) => !(filtersToRemove || []).includes(route.value));
}

export default RoutesCombinedFilter;
